import ProductDescription from './ProductDescription'

const BulgurProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '004',
  IsBroadband: true,
  GrainSize: '',
  Organic: false,
}

export default BulgurProduct
